import { render, staticRenderFns } from "./WikiList.vue?vue&type=template&id=2e27d344&scoped=true&"
import script from "./WikiList.vue?vue&type=script&lang=js&"
export * from "./WikiList.vue?vue&type=script&lang=js&"
import style0 from "./WikiList.vue?vue&type=style&index=0&id=2e27d344&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e27d344",
  null
  
)

export default component.exports